import api from './api';
import type { AdminRateLimitRule, AdminIpWhitelistEntry, AdminRateLimitAnalytics } from '../types/admin';

export const rateLimitService = {
  async listRules(params?: { scope?: string; active?: boolean; per_page?: number; page?: number }) {
    const response = await api.get('/api/admin/rate-limits', { params });
    return response.data as { data: AdminRateLimitRule[] };
  },

  async createRule(payload: Partial<AdminRateLimitRule>) {
    const response = await api.post('/api/admin/rate-limits', payload);
    return response.data as { rule: AdminRateLimitRule };
  },

  async updateRule(ruleId: number, payload: Partial<AdminRateLimitRule>) {
    const response = await api.put(`/api/admin/rate-limits/${ruleId}`, payload);
    return response.data as { rule: AdminRateLimitRule };
  },

  async deleteRule(ruleId: number) {
    const response = await api.delete(`/api/admin/rate-limits/${ruleId}`);
    return response.data;
  },

  async getAnalytics(params?: { from?: string; to?: string }): Promise<AdminRateLimitAnalytics> {
    const response = await api.get('/api/admin/rate-limits/analytics', { params });
    return response.data;
  },

  async listWhitelist(params?: { per_page?: number; page?: number }) {
    const response = await api.get('/api/admin/ip-whitelist', { params });
    return response.data as { data: AdminIpWhitelistEntry[] };
  },

  async addWhitelist(payload: Partial<AdminIpWhitelistEntry>) {
    const response = await api.post('/api/admin/ip-whitelist', payload);
    return response.data as { entry: AdminIpWhitelistEntry };
  },

  async deleteWhitelist(entryId: number) {
    const response = await api.delete(`/api/admin/ip-whitelist/${entryId}`);
    return response.data;
  },

  async testRule(payload: { ip?: string; api_key?: string; campaign_id?: number; account_id?: number; plan_id?: number }) {
    const response = await api.post('/api/admin/rate-limits/test', payload);
    return response.data as { resolution: { rule: AdminRateLimitRule | null; limits: Record<string, unknown>; reason: string; bypass: boolean } };
  },

  async setEmergencyMode(payload: { enabled: boolean; reason?: string }) {
    const response = await api.post('/api/admin/rate-limits/emergency', payload);
    return response.data as { enabled: boolean; message: string };
  },
};

export default rateLimitService;
